import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/product/productContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'
import ReportContext from '@/product/context/report/reportContext'
import Loaders from '@/product/components/molecules/Loaders'
import AlertContext from '@/product/context/alert/alertContext'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDropzone } from 'react-dropzone'

const BulkListing = (props) => {
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const separatorFunction = props.separatorFunction

    const { bulkProjectImageAction, responseStatus: responseStatusProduct } =
        useContext(ProductContext)
    const [isLoading, setIsLoading] = useState(false)
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [reload, setReload] = useState(false)
    const [uploadedImages, setUploadedImages] = useState([])

    console.log('uploadedImages', uploadedImages)
    const auctionAvatar = useDropzone({
        accept: 'image/*',
        multiple: true,
        onDrop: (acceptedFiles) => {
            setIsLoading(true)
            let arr = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            )
            setUploadedImages(uploadedImages.concat(arr))
            setReload(!reload)
            setIsLoading(false)
        },
    })

    const validationArray = Yup.object({})
    const formik = useFormik({
        initialValues: {
            separatorFunction,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (uploadedImages.length) {
                setIsLoading(true)
                let value = values
                var formData = new FormData()
                formData.append(
                    'separatorFunction',
                    JSON.stringify(separatorFunction)
                )
                formData.append('folder', 'product')
                formData.append('isCompress', props.isCompress)
                formData.append('quality', props.quality || '80')
                formData.append('resultWidth', props.resultWidth || '500')
                formData.append('resultHeight', props.resultHeight || '500')
                uploadedImages.forEach((value, key) => {
                    formData.append('file_upload', value)
                })
                bulkProjectImageAction(formData)
            } else {
                setAlert('Please upload images!', 'error')
            }
        },
    })

    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.from === 'bulkProjectImageAction') {
                if (responseStatusProduct.status === 'success') {
                    setUploadedImages([])
                    setIsLoading(false)
                    toggleFullScreenPopup(false)
                } else {
                    setIsLoading(false)
                }
            }
        }
    }, [responseStatusProduct])

    const removeFile = (file, index) => {
        const allFiles = uploadedImages
        if (index > -1) {
            allFiles.splice(index, 1)
        }
        setUploadedImages(allFiles)
        setReload(!reload)
    }
    const lotIDSeparator = (fileField, data, index) => {
        let fieldName = fileField.name.replace(/\.[^/.]+$/, '')
        let details = fieldName.split(data.symbol)
        return details[index] ? details[index] : 'Invalid'
    }

    const viewFile = (file) => {
        let newWindow = null
        newWindow = window.open(
            `${file.preview}`,
            '_blank',
            'noopener,noreferrer'
        )
        if (newWindow) newWindow.opener = null
    }
    return (
        <FullScreenPopup
            modaltitle={`ADD BULK IMAGES`}
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addBulkUpload">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">
                            <div className=" col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="fspTitle">
                                            Upload Bulk Images
                                        </h4>
                                    </div>
                                    <div className="col-12">
                                        <section>
                                            <div
                                                {...auctionAvatar.getRootProps({
                                                    className: 'dropzone',
                                                })}
                                            >
                                                <input
                                                    {...auctionAvatar.getInputProps()}
                                                />
                                                <span className="material-icons">
                                                    {props.icon}
                                                </span>
                                                <h4>
                                                    {props.titleText ||
                                                        'Upload Product Images *'}
                                                </h4>
                                                <h6>
                                                    {props.innerText ||
                                                        'Recommended Size'}
                                                </h6>
                                            </div>

                                            {props.explanationText ? (
                                                <div>
                                                    <h6
                                                        dangerouslySetInnerHTML={{
                                                            __html: props.explanationText,
                                                        }}
                                                    ></h6>
                                                </div>
                                            ) : null}

                                            <p className="validationError text-left">
                                                {formik.touched[props.name] &&
                                                    formik.errors[props.name] &&
                                                    formik.errors[props.name]}
                                            </p>

                                            <aside className="thumbsContainer">
                                                <>
                                                    {isLoading ? (
                                                        <Loaders
                                                            isLoading={
                                                                isLoading
                                                            }
                                                        />
                                                    ) : uploadedImages &&
                                                      uploadedImages.length ? (
                                                        <>
                                                            {uploadedImages.map(
                                                                (
                                                                    file,
                                                                    index
                                                                ) => (
                                                                    <>
                                                                        <div
                                                                            className="thumb"
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <div className="thumbInner">
                                                                                <div className="thumbCnt">
                                                                                    {console.log(
                                                                                        'file Contains',
                                                                                        file
                                                                                    )}
                                                                                    <img
                                                                                        src={`${file.preview}`}
                                                                                        className="img"
                                                                                        id={
                                                                                            'thumb_' +
                                                                                            index
                                                                                        }
                                                                                    />

                                                                                    <div className="fileActions">
                                                                                        <span
                                                                                            onClick={() =>
                                                                                                removeFile(
                                                                                                    file,
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                            className="cancelBtn material-icons"
                                                                                        >
                                                                                            delete
                                                                                        </span>
                                                                                        <span
                                                                                            onClick={() =>
                                                                                                viewFile(
                                                                                                    file
                                                                                                )
                                                                                            }
                                                                                            className="viewBtn material-icons"
                                                                                        >
                                                                                            visibility
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {separatorFunction.map(
                                                                                (
                                                                                    data,
                                                                                    index
                                                                                ) => (
                                                                                    <p
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                        className="m-0"
                                                                                    >
                                                                                        {
                                                                                            data.show
                                                                                        }

                                                                                        :{' '}
                                                                                        {lotIDSeparator(
                                                                                            file,
                                                                                            data,
                                                                                            index
                                                                                        )}
                                                                                    </p>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )
                                                            )}
                                                        </>
                                                    ) : null}
                                                </>
                                            </aside>
                                        </section>
                                    </div>
                                </div>

                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <PrimaryButton
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default BulkListing
